// Outils partagés de la planification.
export const PRIORITES = {
  BASSE: { label: 'Basse', color: 'default' },
  NORMALE: { label: 'Normale', color: 'info' },
  HAUTE: { label: 'Haute', color: 'warning' },
  URGENTE: { label: 'Urgente', color: 'error' },
};
export const STATUTS_TACHE = {
  A_FAIRE: { label: 'À faire', color: 'default' },
  EN_COURS: { label: 'En cours', color: 'info' },
  TERMINEE: { label: 'Terminée', color: 'success' },
  ANNULEE: { label: 'Annulée', color: 'default' },
};
export const ETATS_MAINT = {
  EN_RETARD: { label: 'En retard', color: 'error' },
  A_FAIRE: { label: 'À faire sous 7 j', color: 'warning' },
  OK: { label: 'À jour', color: 'success' },
  INACTIVE: { label: 'Suspendu', color: 'default' },
};
export const STATUTS_LIV = {
  PLANIFIEE: { label: 'Planifiée', color: 'info' },
  REALISEE: { label: 'Réalisée', color: 'success' },
  ANNULEE: { label: 'Annulée', color: 'default' },
};
export const CATEGORIES_TACHE = ['Production', 'Maintenance', 'Nettoyage', 'Stock', 'Livraison', 'Administratif', 'Sécurité', 'Autre'];

export const iso = (d) => d.toISOString().slice(0, 10);
export const plusJours = (d, n) => iso(new Date(Date.parse(`${d}T00:00:00Z`) + n * 86400000));
export const lundiDe = (d) => { const x = new Date(`${d}T00:00:00Z`); return plusJours(d, -((x.getUTCDay() + 6) % 7)); };
const JOURS = ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'];
export const jourCourt = (d) => { const x = new Date(`${d}T00:00:00Z`); return `${JOURS[x.getUTCDay()]} ${String(x.getUTCDate()).padStart(2, '0')}/${String(x.getUTCMonth() + 1).padStart(2, '0')}`; };
export const semaineLabel = (debut) => `Semaine du ${jourCourt(debut).slice(4)} au ${jourCourt(plusJours(debut, 6)).slice(4)}`;
export const aujourdhui = () => iso(new Date(Date.now() - new Date().getTimezoneOffset() * 60000));
